import React, { FC, ReactElement, useState } from 'react';
// import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { TabPanel } from '../../components/TabPanel';
import { RootState, selectCurrentMarket } from '../../modules';
// import { MarketDepthsComponent } from '../index';
import { selectChartData } from '../../modules/public/chart/selector';
import StockChart from '../StockChart/StockChart';

export const Charts: FC = (): ReactElement => {
    const data = useSelector((state: RootState) => selectChartData(state));
    const currentMarket = useSelector(selectCurrentMarket);
    const [ currentTabIndex, setCurrentTabIndex ] = useState(0);

    const renderTabs = () => [
        {
            content: currentTabIndex === 0 ? <StockChart data={data} /> : null,
            label: "Chart"
        },
    ];

    return (
        <div className="pg-charts">
            <TabPanel
                optionalHead={currentMarket?.name}
                panels={renderTabs()}
                currentTabIndex={currentTabIndex}
                onCurrentTabChange={setCurrentTabIndex}
            />
        </div>
    );
};
